import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import img1 from "../Assets/Team/dhruv.png";
import img2 from "../Assets/Team/pallavi.png";
import img3 from "../Assets/Team/pratik.png";
import img4 from "../Assets/Team/ruchita.png";
import img5 from "../Assets/Team/shubham.png";
import img6 from "../Assets/Team/uziaf.png";
import img7 from "../Assets/Team/yogesh.png";


// Add more images as needed
const images = [img1, img2, img3, img4, img5, img6, img7 ];

const StudioCarousel = () => {
  const commonSettings = {
    infinite: true,
    autoplay: true,
    speed: 4000,
    autoplaySpeed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    pauseOnHover: false,
    centerMode: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: false,
        },
      },
    ],
  };

  const topSliderSettings = { ...commonSettings };
  const bottomSliderSettings = { ...commonSettings, rtl: true };

  return (
    <div style={styles.wrapper}>
      <div style={styles.overlay}>
        <h1 style={styles.heading}>
          We Build Content that People Won’t Stop Scrolling
        </h1>
        {/* <div style={styles.studio}>STUDIO</div> */}
      </div>

      {/* Top Slider */}
      <div style={styles.sliderTop}>
        <Slider {...topSliderSettings}>
          {images.map((img, index) => (
            <div key={`top-${index}`} style={styles.imageContainer}>
              <div style={styles.imageWrapper}>
                <img src={img} alt={`team-top-${index}`} style={styles.image} />
                <div style={styles.overlayLayer}></div>
              </div>
            </div>
          ))}
        </Slider>
      </div>

      {/* Bottom Slider */}
      <div style={styles.sliderBottom}>
        <Slider {...bottomSliderSettings}>
          {images.map((img, index) => (
            <div key={`bottom-${index}`} style={styles.imageContainer}>
              <div style={styles.imageWrapper}>
                <img src={img} alt={`team-bottom-${index}`} style={styles.image}/>
                <div style={styles.overlayLayer}></div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    position: "relative",
    width: "100%",
    height: "115vh",
    overflow: "hidden",
    marginTop: "10px",
    backgroundColor: "#000",
    color: "#d1ff51",
  },
  overlay: {
    position: "absolute",
    zIndex: 3,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
  },
  heading: {
    fontSize: "3rem",
    fontWeight: "900",
    lineHeight: 1.1,
    color: "#d1ff51",
    marginBottom:'20%'
  },
  studio: {
    marginTop: 15,
    fontSize: "1.5rem",
    fontWeight: "bold",
    border: "2px solid #d1ff51",
    padding: "5px 20px",
    display: "inline-block",
    borderRadius: "20px",
  },
  sliderTop: {
    position: "absolute",
    top: 0,
    width: "100%",
    height: "50%",
    zIndex: 1,
  },
  sliderBottom: {
    position: "absolute",
    bottom: 0,
    width: "100%",
    height: "50%",
    zIndex: 1,
  },
  imageContainer: {
    padding: "0px",
    transform: "rotate(-5deg)",
  },
  imageWrapper: {
    position: "relative",
    width: "95%",
    height: "300px",
    overflow: "hidden",
    borderRadius: "6px",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    filter: "grayscale(100%)",
    position: "relative",
    zIndex: 1,
  },
  overlayLayer: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    zIndex: 2,
  },
};

export default StudioCarousel;
